export default "__VITE_ASSET__73f8a9f2__"